export enum CashRegisterPaymentType {
  Card = 'CARD',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  NotCollected = 'NOT_COLLECTED',
  NotCollectedInvoice = 'NOT_COLLECTED_INVOICE',
  PayDiscount = 'PAY_DISCOUNT',
  WireTransfer = 'WIRE_TRANSFER',
}
